module.exports = __webpack_public_path__ + "d6548ecdb0406a8e6c651c8664806cf8.jpg";